var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReduceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3506 10.8984C12.3506 11.3127 12.6864 11.6484 13.1006 11.6484L19.8506 11.6484C20.2648 11.6484 20.6006 11.3127 20.6006 10.8984C20.6006 10.4842 20.2648 10.1484 19.8506 10.1484L13.8506 10.1484L13.8506 4.14844C13.8506 3.73422 13.5148 3.39844 13.1006 3.39844C12.6864 3.39844 12.3506 3.73422 12.3506 4.14844L12.3506 10.8984ZM13.1006 10.8984L13.6309 11.4288L23.5304 1.52927L23.0001 0.998942L22.4698 0.468612L12.5703 10.3681L13.1006 10.8984Z",
    fill: "#6C6859"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.043 12.7079C12.043 12.2937 11.7073 11.9579 11.293 11.9579L4.54305 11.9579C4.12884 11.9579 3.79305 12.2937 3.79305 12.7079C3.79305 13.1221 4.12884 13.4579 4.54305 13.4579H10.5431V19.4579C10.5431 19.8721 10.8788 20.2079 11.2931 20.2079C11.7073 20.2079 12.0431 19.8721 12.043 19.4579L12.043 12.7079ZM1.39355 22.6074L1.92388 23.1378L11.8234 13.2383L11.2931 12.7079L10.7627 12.1776L0.863225 22.0771L1.39355 22.6074Z",
    fill: "#6C6859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceIcon);
export default __webpack_public_path__ + "static/media/ReduceIcon.e88fdf4adf63c74d0f8431f6429e35a1.svg";
export { ForwardRef as ReactComponent };